/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Inventory {

    import fld = CertificationIssueItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class CertificationIssueItemsEditor extends _Ext.ItemGridEditor<CertificationIssueItemsRow> {


        protected getColumnsKey() { return "Inventory.CertificationIssueItems"; }
        protected getDialogType() { return CertificationIssueItemsDialog; }
        protected getLocalTextPrefix() { return CertificationIssueItemsRow.localTextPrefix; }
        protected form: CertificationIssueItemsForm;
        protected get_ExtGridOptions() {
            let opt = super.get_ExtGridOptions();
            opt.AutoColumnSize = true;
            opt.ShowDeleteInlineButtun = false;
            opt.ShowRowNumberColumn = false;
            return opt;
        }
        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public TransDate: Date;
        public ExchangeRate: number;
        public DeptId: number; 
        // #endregion
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.onRender.subscribe(() => {
                this.SetInlineLookupEditor();
            });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as CertificationIssueDialog).CalculateAmountandTax(this.view.getItems() );
                }
            })
        }
        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var Process = Q.first(columns, x => x.field === fld.ProcessId);
            Process.referencedFields = [fld.ProcessId];
            Process.format = ctx => {
                var width = (ctx.column.width) as number - 10;
                return '<input type="hidden" style="text-align: right; width:' + width + 'px;" id="ProcessId' + ctx.row + '" title="Process" />';
            };

            Q.first(columns, x => x.field === fld.Pieces).format = num;
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = wt;
            Q.first(columns, x => x.field === fld.NetWeight).format = wt;


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public SetInlineLookupEditor() {
            // course of all the lines present in the grid
            var Items = this.view.getItems();
            if (Items.length > 0)
                for (let Item in Items) {
                    this.InlineLookup(Item, Items);
                }
        }

        private InlineLookup(RowIndex: string, Items: CertificationIssueItemsRow[]) {

            var select = $("#ProcessId" + RowIndex);

            if (!select.hasClass("select2-offscreen")) {

                let opt: Serenity.LookupEditorOptions = {
                    lookupKey: 'FGandWIPProcess'
                };
                var Editor = new TabAurous.InlineLookupEditor($("#ProcessId" + RowIndex), opt);
                if (this.isReadOnly == true) {
                    q.showAndDisableField(Editor);
                }

                Editor.value = Items[RowIndex].ProcessId;
                Editor.changeSelect2(e => {
                    Items[RowIndex].ProcessId = Q.toId(Editor.value);
                });
            }
            else {
                if (this.isReadOnly == false) {
                    select.closest('.slick-cell').find('.select2-container-disabled').removeClass('select2-container-disabled');
                    //select.removeAttr("disabled");
                    select.removeAttr("readonly");
                    //select.removeClass('readonly');                   
                }
            }
        }


        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item); 
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                    (this.parentDialog as CertificationIssueDialog).CalculateAmountandTax(this.view.getItems());

                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;

                        var input = $(e.target);
                        var y = input.data();
                        if (y.field == "Weight" && item.ItemTypeId == 101) {
                            target.addClass('readonly');
                            target.blur();
                        }
                        else if (y.field == "Pieces" && item.ItemTypeId == 104) {
                            target.addClass('readonly');
                            target.blur();
                        } 
                    }

                    this.view.refresh();
                    (this.parentDialog as CertificationIssueDialog).CalculateAmountandTax(this.view.getItems());

                }
            }
        }
        setData(Items) {
            //set data in Material Grid from Job Work

            let BOMdetails;
            for (let item of Items) {
                BOMdetails = item.BOMDetails;
                for (let BOM of BOMdetails) {
                    var detail: Inventory.CertificationIssueItemsRow = {
                        AttributeId: BOM.BOMAttributeId,
                        ProductCode: BOM.ProductCode,
                        ProductId: BOM.ProductId,
                        ProductName: BOM.ProductName,
                        SKU: item.SKU,
                        Line_No: item.Line_No,
                        Pieces: BOM.Pieces,
                        Weight: BOM.Weight,
                        HSN: item.HSN
                    };
                    detail[this.getIdProperty()] = "`" + this.nextId++;
                    this.view.addItem(detail);

                }
            }
        }

        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Pieces || field === fld.Discount) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {

                if (item.CalcOnId == 3) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;

                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                if (item.CalcOnId == 4 || item.CalcOnId == 5) {
                    item.GrossAmount = item.UnitRate * value;
                    item.NetAmount = item.UnitRate * value;
                    item.NetWeight = value;
                    item[field] = value;

                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as CertificationIssueDialog).CalculateAmountandTax(this.view.getItems());

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion
        setMasterValues() {
            this.RateListId = (this.parentDialog as CertificationIssueDialog).RateListId;
            this.LaborListId = (this.parentDialog as CertificationIssueDialog).LaborMarkup;
            this.StoneMarkup = (this.parentDialog as CertificationIssueDialog).StoneMarkup;
            this.StoneDiscount = (this.parentDialog as CertificationIssueDialog).StoneDiscount;
            this.LaborMarkup = (this.parentDialog as CertificationIssueDialog).LaborMarkup;
            this.LaborDiscount = (this.parentDialog as CertificationIssueDialog).LaborDiscount;
            this.ExchangeRate = (this.parentDialog as CertificationIssueDialog).ExchangeRate;
            this.TransDate = (this.parentDialog as CertificationIssueDialog).form.TransDate.valueAsDate;
            this.PartyId = parseInt((this.parentDialog as CertificationIssueDialog).form.PartyId.value);
        }

        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Items",
                cssClass: "stock-button",
                hotkey: 'alt+k',
                hint: 'alt+k',
                onClick: () => {
                    this.setMasterValues();

                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Customer to proceed");
                        return;
                    }
                    else {
                        var grid = Common.StockSelectGrid;

                        var filters: _Ext.SelectGridFilters = {
                            FilterItems: 3
                        }

                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true,
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }
                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var ItemDetails = ItemGridHelper.SetSalesItemGrid(selectedItems2, this.TransDate, this.PartyId, this.ExchangeRate, this.RateListId, this.LaborListId, this.LaborMarkup);
                        this.setGridData(ItemDetails);
                    }

                    pickerDialog.element.bind('dialogclose', () => {

                        this.element.trigger('dialogclose');

                    });
                    pickerDialog.dialogOpen();

                },
                disabled: this.readOnly ? true : false
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }

        setGridData(ItemDetails: any[]) {
            for (let Itemdetail of ItemDetails) {
                var Item = Itemdetail;
                var InventoryItem: Inventory.CertificationIssueItemsRow = {
                    ProductId: Item.ProductId,
                    AttributeId: Item.AttributeId,
                    Attribute: Item.Attribute,
                    Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                    SKU: Item.SKU,
                    LotNo: Item.LotNo,
                    BagNo: Item.BagNo,
                    Lab: Item.Lab,
                    CertificateNo: Item.CertificateNo,
                    DepartmentId: Item.DepartmentId,
                    DeptName: Item.DeptName,
                    ProductCode: Item.ProductCode,
                    ProductName: Item.ProductName,
                    ItemTypeId: Item.ItemTypeId,
                    HasBom: Item.HasBom,
                    CategoryId: Item.CategoryId,
                    ProductTypeId: Item.ProductTypeId,
                    SubCategoryId: Item.SubCategoryId,
                    BrandId: Item.BrandId,
                    SuperTypeId: Item.SuperTypeId,
                    CollectionId: Item.CollectionId,
                    UnitRate: Item.Rate,
                    UnitLabour: Item.UnitLabour,
                    UnitCost: Item.Cost,
                    Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                    Weight: Item.Weight,
                    OtherPieces: Item.OtherPieces,
                    OtherWeight: Item.OtherWeight,
                    StonePieces: Item.StonePieces,
                    StoneWeight: Item.StoneWeight,
                    NetWeight: Item.NetWeight,
                    NetAmount: Item.NetAmount,
                    GrossAmount: Item.GrossAmount,
                    DiamondPieces: Item.DiamondPieces,
                    DiamondWeight: Item.DiamondWeight,
                    CalcOnId: Item.CalcOnId,
                    BOMDetails: Item.BOMDetails,
                    CompanyId: Item.CompanyId,
                    HSN: Item.HSN,
                    TaxCode: Item.TaxCode,
                    MetalId: Item.MetalId,
                    KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                    MetalColorId: Item.MetalColorId,
                    QualityId: Item.QualityId,
                    SieveId: Item.SieveId,
                    ShapeId: Item.ShapeId,
                    StoneColorId: Item.StoneColorId,
                    StoneSizeId: Item.StoneSizeId,
                    ImageName: Item.ImageName,
                    Studded: Item.Studded, // marking item as bulk
                    StoneCutId: Item.StoneCutId,
                    StonePolishId: Item.StonePolishId,
                    StoneSymmetryId: Item.StoneSymmetryId,
                    StoneFluorescenceId: Item.StoneFluorescenceId,
                    StoneCuletId: Item.StoneCuletId,
                    StoneGirdleId: Item.StoneGirdleId,
                    StoneTable: Item.StoneTable,
                    StoneDepth: Item.StoneDepth,
                    Purity: Item.Purity,
                    CalcUnitId: Item.CalcUnitId,
                    PureWeight: Item.Weight * Item.Purity,
                    RefVoucherId: Item.RefVoucherId,
                    RefTransId: Item.RefTransId,
                    RefTransItemId: Item.RefTransItemId,
                    CCGrossAmount: Item.Amount * Item.ExchangeRate,
                    CCNetAmount: Item.Amount * Item.ExchangeRate,
                    ProcessId: Item.ProcessId,
                    StockAllocation: Item.StockAllocation
                    
                };


                InventoryItem[this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(InventoryItem);
            }
        }
    }
}